import { CalendarIcon, ClipboardCheckIcon, RulerIcon, ZapIcon, ShieldAlertIcon, BarChart3Icon, type LucideIcon } from 'lucide-react';

export interface Bonus {
  icon: LucideIcon;
  emoji: string;
  title: string;
  value: string;
  text: string;
}

export const bonuses: Bonus[] = [
  {
    icon: CalendarIcon,
    emoji: '🗓️',
    title: 'Mapa Flash de Arranque 7 Días',
    value: '14,90€',
    text: 'La hoja de ruta exacta para aplicar EDUCACIÓN FÍSICA FLASH desde el primer día sin perderte entre 360 páginas. Diagnóstico del grupo, primera sesión lista y primer comentario a familias en solo 7 días.'
  },
  {
    icon: ClipboardCheckIcon,
    emoji: '📋',
    title: 'Chuleta LOMLOE de Patio',
    value: '12,90€',
    text: 'Frases copiables para justificar cualquier sesión en lenguaje curricular. Códigos LOMLOE, criterios observables, plantillas de comentarios trimestrales. Cuando inspección pregunta, tienes respuesta.'
  },
  {
    icon: RulerIcon,
    emoji: '📐',
    title: 'Kit Visual "Mira y Pita"',
    value: '15,90€',
    text: 'Plantillas de fichas visuales para convertir cualquier sesión en un documento de campo. Iconos profesionales, diagramas, versión A4 imprimible y versión móvil. Consulta en el patio en 10 segundos.'
  },
  {
    icon: ZapIcon,
    emoji: '⚡',
    title: 'Scripts de Explicación en 15 Segundos',
    value: '11,90€',
    text: 'Frases exactas para explicar actividades sin perder atención del grupo. Estructura probada: Acción, Propósito, Norma, Transición. Nunca más explicación larga que aburra.'
  },
  {
    icon: ShieldAlertIcon,
    emoji: '🛑',
    title: 'Panel Anticaos del Profe de EF',
    value: '13,90€',
    text: 'Sistema de señales, normas y rutinas para controlar la clase sin gritar. 5 señales, 6 normas, rutina de entrada/salida. El orden que hace que todo funcione.'
  },
  {
    icon: BarChart3Icon,
    emoji: '📊',
    title: 'Tracker Flash de Progreso y Evidencias',
    value: '20,10€',
    text: 'Registra evaluación en segundos sin burocracia. 5 indicadores clave, plantillas semanales, gráficos de progreso, cálculo de calificación. Datos que defienden tu evaluación.'
  }
];
